module.exports = __webpack_public_path__ + "static/img/img-4-2.ea2998b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4-2.png
// module id = f3I6
// module chunks = 0